<template>
<!--    <div class="bigBox">-->
<!--      <nav-tars :navs="navs"></nav-tars>-->
<!--      <el-card class="box-card" style="margin-top: 20px">-->
<!--        <el-row  class="nav_box" v-for="list in lists">-->
<!--          <el-col :span="3"><div class="grid-content bg-purple">-->
<!--            <el-image :src="list.img" style="width: 25px;height: 25px;margin-top: -5px;"></el-image>-->
<!--          </div></el-col>-->
<!--          <el-col :span="13"><div class="grid-content bg-purple-light">-->
<!--            <span class="tx">{{list.name}}</span>-->
<!--          </div></el-col>-->
<!--          <el-col :span="8"><div class="grid-content bg-purple">-->
<!--            <router-link :to="{path: list.path}">-->
<!--              <span class="el-icon-arrow-right" style="float: right"></span>-->
<!--            </router-link>-->
<!--          </div></el-col>-->
<!--          <div v-if="list.name!='物流信息查询'" style="margin-top: 40px;">-->
<!--            <el-divider></el-divider>-->
<!--          </div>-->
<!--        </el-row>-->

<!--      </el-card>-->
<!--    </div>-->
   <div>
       <div class="header" >
           <div style="width: 100%;height: 50px;background-color: #fff;line-height: 50px;text-align: center;position: relative">
               <div style="color: #4D586D;position: relative">报表
                   <div class="grid-content bg-purple " style="position: absolute;left: 10px;top: 0px;color: #FF9901">
                       <span class="el-icon-arrow-left" @click="bk()">返回</span>
                   </div>
               </div>
           </div>
       </div>
       <div class="bigBox" style="background-color: #fff;margin-top: 20px">
      <div  class="nav_box" v-for="list in lists" @click="choose(list)">

          <div class="grid-content bg-purple">
            <el-image :src="list.img" style="width: 25px;height: 25px;"></el-image>
          </div>

          <div class="grid-content bg-purple-light" style="margin-left: 20px">
            <span class="tx">{{list.name}}</span>
          </div>

          <div class="grid-content bg-purple" style="position: absolute;right: 14px">
            <router-link :to="{path: list.path}">
              <span class="el-icon-arrow-right" ></span>
            </router-link>
          </div>


      </div>

  </div>
   </div>
</template>
<script>
import navTars from "./navTars";
export default {
  name:"login",
  components:{
    navTars
  },
  data() {
    return {
      navs:'报表',
      lists:[
        {name:"商品库存查询",path:'/Inventory',img:require('./../../assets/images/kucun.png')},
        {name:"活动查询",path:'/Activity',img:require('./../../assets/images/huodong.png')},
        {name:"个人指标完成情况",path:'/Personal',img:require('./../../assets/images/zhibiao.png')},
        {name:"拜访查询",path:'/Visit',img:require('./../../assets/images/baifang.png')},
        {name:"销量分析",path:'/Sales',img:require('./../../assets/images/xiaoliang.png')},
        {name:"订单查询",path:'/OrderQuery',img:require('./../../assets/images/dingdan.png')},
        {name:"业务员排行榜",path:'/Salesman',img:require('./../../assets/images/yewu.png')},
        {name:"物流信息查询",path:'/Logistics',img:require('./../../assets/images/wuliu.png')},
      ]
    }
  },
  methods:{
    choose(list){

      this.$router.push(list.path)
    }
  }
}
</script>
<style lang="scss">
  .tx{
    color:#4D586D;
    font-size: 16px;
  }
  .ic{
    float: right;
  }
  a{
    color: gray;
    text-decoration: none
  }
  .nav_box{
    padding: 13px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items:center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/reportIndex.vue